var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DarkCard',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',[_vm._v("Active Alerts")]),_c('i',{staticClass:"fa fa-comment-o"})]},proxy:true},{key:"body",fn:function(){return [_c('span',[_vm._v(_vm._s(_vm.alerts ?? '--')+" ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }